import React, { useState, useMemo } from 'react';
import '../style/css/listing2026.css';

// Reusable listing screen (invites / waiting / blacklist / clients). Token-based table
// with search + responsive card view + empty state. Data-driven via props so each screen
// just supplies title/count/columns/rows. Real data wiring: TODO once PHP acts exist
// (see docs/HOSTESS_APP_PHP_ADAPTATION_SCAN.md).
export default function ListingPage({ title, count, columns = [], rows = [], emptyText = 'אין נתונים להצגה' }) {
    const [query, setQuery] = useState('');
    // Count reflects the real rows unless a caller overrides it — never a hardcoded fake total.
    const shownCount = count != null ? count : rows.length;

    const filtered = useMemo(() => {
        const q = query.trim();
        if (!q) return rows;
        return rows.filter((r) => columns.some((c) => String(r[c.id] ?? '').includes(q)));
    }, [query, rows, columns]);

    return (
        <div className="lst-page">
            <div className="lst-head">
                <div className="lst-head-right">
                    <span className="lst-count">{shownCount}</span>
                    <h1 className="lst-title">{title}</h1>
                </div>
                <input className="lst-search" type="search" placeholder="חיפוש..."
                    value={query} onChange={(e) => setQuery(e.target.value)} />
            </div>

            <div className="lst-card">
                {filtered.length ? (
                    <table className="lst-table">
                        <thead>
                            <tr>{columns.map((c) => <th key={c.id}>{c.text}</th>)}</tr>
                        </thead>
                        <tbody>
                            {filtered.map((row, i) => (
                                <tr key={row.id ?? i}>
                                    {columns.map((c) => <td key={c.id} data-label={c.text}>{c.render ? c.render(row) : row[c.id]}</td>)}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div className="lst-empty">{emptyText}</div>
                )}
            </div>
        </div>
    );
}
